export default __webpack_public_path__ + "static/media/general_interview.af77cc64.png";